import type { LanguageCode } from '@repo/domain';
import type { TestId } from '@repo/test-id';
import { Dropdown, type DropdownOption, type DropdownVariant } from '@repo/ui';

import LanguageOptionLabel from '@shared/components/language/LanguageOptionLabel';
import { LANGUAGE_OPTIONS } from '@shared/constants/languageOptions';

interface Props {
  value: LanguageCode;
  onChange: (value: LanguageCode) => void;
  testId: TestId;
  enablePortal?: boolean;
  variant?: DropdownVariant;
}

const DROPDOWN_OPTIONS: DropdownOption<LanguageCode>[] = LANGUAGE_OPTIONS.map((option) => ({
  value: option.value,
  label: <LanguageOptionLabel flag={option.flag} text={option.label} />,
}));

export default function LanguageDropdown({ value, onChange, testId, enablePortal = true, variant = 'default' }: Props) {
  const handleChange = (next: LanguageCode | null) => {
    if (next) onChange(next);
  };

  return (
    <Dropdown<LanguageCode>
      testId={testId}
      options={DROPDOWN_OPTIONS}
      value={value}
      onChange={handleChange}
      enablePortal={enablePortal}
      variant={variant}
    />
  );
}
